import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LoaderOverlay } from './components/shared/loader-overlay/loader-overlay';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderOverlay, ConfirmDialogModule],
  template: `
    <router-outlet></router-outlet>
    <app-loader-overlay message="Loading..."></app-loader-overlay>
    <p-confirmDialog [style]="{ width: 'min(420px, 92vw)' }" maskStyleClass="p-confirmdialog-mask-soft" />
  `,
})
export class App implements OnInit {
  constructor(private readonly themeService: ThemeService) {}

  private altDToggleConsumed = false;

  ngOnInit(): void {
    this.themeService.initializeTheme();
  }

  // Toggle theme only on Alt+D, once per key press.
  @HostListener('window:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent): void {
    const key = (event.key || '').toLowerCase();
    const isKeyD = event.code === 'KeyD' || key === 'd';
    if (!isKeyD) {
      return;
    }

    const isAltD = event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

    if (isAltD && !this.altDToggleConsumed) {
      event.preventDefault();
      event.stopPropagation();
      this.altDToggleConsumed = true;
      this.themeService.toggleTheme();
    }
  }

  @HostListener('window:keyup', ['$event'])
  onGlobalKeyup(event: KeyboardEvent): void {
    const key = (event.key || '').toLowerCase();
    const isAltOrDKey = key === 'alt' || key === 'd' || event.code === 'KeyD';
    if (isAltOrDKey) {
      this.altDToggleConsumed = false;
    }
  }

}